import { useRouter } from "next/router";
import { Page as Component } from "~/components/specifics/vendors/deals/index/Page";
import { useSessions } from "~/hooks/vendors/useSessions";

export function Page() {
	const router = useRouter();
	const { isLoading } = useSessions().index();
	if (isLoading || !router.isReady) {
		return <></>;
	}
	return <Component />;
}
